export const LOCATION_PERMISSION_GRANTED_EVENT = "stasht:location-permission-granted";

export function notifyLocationPermissionGranted() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(LOCATION_PERMISSION_GRANTED_EVENT));
}
